<template>
    <div v-if="isVisible"
         class="popup-overlay">
<!--         @click.self="closePopup"-->

        <div class="popup-content">
            <div class="print-header">
                <button class="close" @click="closePopup">&times;</button>
            </div>
            <slot>

            </slot>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        openPopup() {
            this.isVisible = true;
        },
        closePopup() {
            this.isVisible = false;
        }
    }
};
</script>

<style scoped>
.close {
    margin-top: -18px;
    margin-right: -10px;
    font-size: 30px;
}
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7); /* Greyed-out background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.popup-content {
    display: block;
    position: relative;
    background-color: white;
    width: 80%;
    height: 80%;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}
</style>
